import requestService from '@/services/request.service'
import { store } from '@/store/store'
import { PagedData } from '@/types/page'

import { FETCHING_MORE, FETCHING_MORE_ERROR, FETCHING_MORE_SUCCESS } from './types'

export type FetchingMoreActionType = {
  type: typeof FETCHING_MORE
}

export type FetchingMoreErrorActionType = {
  type: typeof FETCHING_MORE_ERROR
}

export type FetchingMoreSuccessActionType = {
  payload: {
    index: number
    newPage: PagedData
  }
  type: typeof FETCHING_MORE_SUCCESS
}

export const fetchMore = async (index: number) => {
  const dispatch = store.dispatch
  const { cardLists } = store.getState().cardlists
  const more = cardLists[index]?.more

  if (!more) return

  dispatch({ type: FETCHING_MORE })
  try {
    const res = await requestService.get(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/${more}`, {}, true)
    const newPage = (await res.json()) as PagedData
    dispatch({
      payload: {
        index,
        newPage,
      },
      type: FETCHING_MORE_SUCCESS,
    })
  } catch (err) {
    console.error(err)
    dispatch({ type: FETCHING_MORE_ERROR })
  }
}
